module.exports = __webpack_public_path__ + "img/Réalisation portail avec poteaux alu et motorisation.fd386f8d.jpg";